import FAVICONS from 'shared/favicons';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

const MAIN_PREFIX = '/admin-pages/stats/';

const STATS_PAGE_CHILDREN = [
    {
        name: 'stats-reports',
        path: 'reports',
        component: () => import(/* webpackChunkName: "adminStats" */ './StatsPageReports.vue'),
        props: true
    },
    {
        name: 'stats-insights',
        path: 'insights',
        component: () => import(/* webpackChunkName: "adminStats" */ './StatsPageInsights.vue'),
        props: true
    },
    {
        name: 'stats-users',
        path: 'users',
        component: () => import(/* webpackChunkName: "adminStats" */ './stats_users/StatsPageUsers.vue'),
        props: true
    },
    {
        name: 'stats-goals',
        path: 'goals',
        component: () => import(/* webpackChunkName: "adminStats" */ './stats_goals/StatsPageGoals.vue'),
        props: true
    },
    {
        name: 'stats-default',
        path: '',
        // by name: router 4 resolves a string redirect against the root, so the relative
        // 'users' this used to be sent /admin-pages/stats/ to /users
        redirect: {name: 'stats-users'},
    },
];

export default defineSection({
    head: sectionHead({title: 'Insights', icon: FAVICONS.insights}),
    // no setup: the pages reach the store through `useStatsPageStore`, which builds it
    // on first use
    routes: [
        {
            path: MAIN_PREFIX,
            component: () => import(/* webpackChunkName: "adminStats" */ './StatsPageContainer.vue'),
            props: true,
            children: STATS_PAGE_CHILDREN
        },
    ]
});
